module.exports = __webpack_public_path__ + "static/media/grab_alc_singha_320_24.c703881a.jpg";